import type { ProjektId } from "../../../../lib/validation/lite/IDSchemas";

export const createQueryId = (projektId: ProjektId) =>
	`project:query:${projektId}`;
export const createCommandId = (projektId: ProjektId) =>
	`project:command:${projektId}`;
